import { render, staticRenderFns } from "./pageIndex_bak.vue?vue&type=template&id=3c8a5986&scoped=true"
import script from "./pageIndex_bak.vue?vue&type=script&lang=js"
export * from "./pageIndex_bak.vue?vue&type=script&lang=js"
import style0 from "./pageIndex_bak.vue?vue&type=style&index=0&id=3c8a5986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8a5986",
  null
  
)

export default component.exports